import { z } from 'zod';
import { paginationMetaSchema } from '@/api/pagination';
import { billingApprovalTotalsSchema } from '@/features/billing/types/billing.types';

export const dcrApproveRowSchema = z.object({
  recordId: z.coerce.number(),
  dcrNo: z.coerce.number(),
  dcrDate: z.string(),
  dcrTypeCode: z.string().nullable(),
  dcrType: z.string().nullable(),
  fiscalYear: z.string().nullable(),
  userId: z.coerce.number(),
  zmName: z.string().nullable(),
  zmMobile: z.string().nullable(),
  zmDesignation: z.string().nullable(),
  isRefZm: z.boolean(),
  refZmName: z.string().nullable(),
  refZmMobile: z.string().nullable(),
  instituteId: z.coerce.number().nullable(),
  instituteNo: z.coerce.number().nullable(),
  instituteName: z.string().nullable(),
  instituteNameBng: z.string().nullable(),
  instituteDesc: z.string().nullable(),
  instituteDbId: z.string().nullable(),
  eiinNumber: z.string().nullable(),
  instituteTypeCode: z.string().nullable(),
  instituteTypeName: z.string().nullable(),
  transportType: z.string().nullable(),
  approveTransportType: z.string().nullable(),
  fareAmount: z.number(),
  approveFareAmount: z.number(),
  timeFrom: z.string().nullable(),
  timeTo: z.string().nullable(),
  workAreaFromName: z.string().nullable(),
  workAreaToName: z.string().nullable(),
  approveTypeNo: z.number(),
  approveType: z.string().nullable(),
  isVerify: z.number(),
  isManualEntry: z.boolean(),
  comments: z.string().nullable(),
});

export const dcrApproveResponseSchema = z.object({
  data: z.array(dcrApproveRowSchema),
  meta: paginationMetaSchema.extend({ totals: billingApprovalTotalsSchema }),
});

export type DcrApproveRow = z.infer<typeof dcrApproveRowSchema>;
export type DcrApproveResponse = z.infer<typeof dcrApproveResponseSchema>;

export const dcrApproveSearchSchema = z.object({
  dcrNo: z.coerce.number().optional(),
  dcrTypeId: z.coerce.number().optional(),
  fiscalYearId: z.coerce.number().optional(),
  userId: z.coerce.number().optional(),
  instituteTypeId: z.coerce.number().optional(),
  transportTypeId: z.coerce.number().optional(),
  approveTransportTypeId: z.coerce.number().optional(),
  approveTypeNo: z.coerce.number().optional(),
  isVerify: z.coerce.number().optional(),
  isManualEntry: z.union([z.literal('true'), z.literal('false')]).optional(),
  isRefZm: z.union([z.literal('true'), z.literal('false')]).optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  search: z.string().optional(),
});

export type DcrApproveSearch = z.infer<typeof dcrApproveSearchSchema>;
